import { NewsIndexClient } from 'hb-react/frontoffice/apps/NewsIndex/startup/NewsIndexClient';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

const NewsAppClient = ({ _baseUrl, ...props }) => {
  const { currentNetwork } = useDefaultAppContexts();

  return (
    <NewsIndexClient
      config={props.config}
      network={currentNetwork}
      topic={props.topic}
    />
  );
};

export default NewsAppClient;
